var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import api from '@utils/axios';
const NAME_ONLY_META = 'meta[name="material-search-name-only"]';
const PREFERENCE_URL_META = 'meta[name="material-search-preference-url"]';
const readMeta = (selector) => { var _a, _b; return (_b = (_a = document.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : null; };
const writeMeta = (value) => {
    var _a;
    (_a = document.querySelector(NAME_ONLY_META)) === null || _a === void 0 ? void 0 : _a.setAttribute('content', String(value));
};
// Module-level store so every hook instance (one per line item row) sees the same preference.
let currentValue = null;
const subscribers = new Set();
const getSnapshot = () => {
    if (currentValue === null)
        currentValue = readMeta(NAME_ONLY_META) === 'true';
    return currentValue;
};
const subscribe = (listener) => {
    subscribers.add(listener);
    return () => {
        subscribers.delete(listener);
    };
};
const setStore = (value) => {
    currentValue = value;
    writeMeta(value);
    subscribers.forEach((listener) => listener());
};
/** Test-only: forget the cached value so the next read re-initialises from the meta tag. */
export const resetNameOnlyPreferenceStore = () => {
    currentValue = null;
    subscribers.forEach((listener) => listener());
};
export function useNameOnlyPreference() {
    const [nameOnly, setNameOnlyState] = useState(getSnapshot);
    useEffect(() => {
        const sync = () => setNameOnlyState(getSnapshot());
        sync();
        return subscribe(sync);
    }, []);
    const setNameOnly = useCallback((value) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const previous = getSnapshot();
        setStore(value);
        try {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            yield api.patch((_a = readMeta(PREFERENCE_URL_META)) !== null && _a !== void 0 ? _a : '', { name_only: value });
        }
        catch (error) {
            setStore(previous);
        }
    }), []);
    return [nameOnly, setNameOnly];
}
